import React, { useEffect, useState } from "react";
import styles from "./../celebrationEvent.module.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../../../component/table";
import { deleteIcon, editIcon } from "../../../../utils/svg.file";

import { Featured_URL } from "../../../../serverUrl";
import DeleteModal from "../../../component/modal/deleteModal";
import swal from "sweetalert";
import { addCelebrationData, deleteCelebrationlist, showCelebrationsList } from "../../../../api/adminPanel/giftCardApi";

export default function ManageBannerAndContent() {
  const navigate = useNavigate();
  const [featuredList, setFeaturedList] = useState([]);
  const [celebrationList, setCelebrationList] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState("");
  const [deleteId, setDeletedId] = useState("");
  const handleShowDeleteModal = (id) => {
    setDeletedId(id);
    setShowDeleteModal(true);
  };
  const hideDeleteModal = () => {
    setShowDeleteModal(false);
  };
  

  const columns = [
    { field: "id", headerName: "SNo.", width: 100 },
    { field: "location", headerName: "Location", height: 300, width: 150 },

    { field: "title", headerName: "Title", height: 300, width: 150 },

    {
      field: "description",
      headerName: "Description",
      height: 300,
      width: 400,
    },
    {
      field: "Action",
      width: 150,
      renderCell: (cellValues) => {
        return (
          <>
            <span
              className={styles.edit_icon_btn}
              onClick={() => {
                navigate(
                  `/edit-celebration-banner-content/${cellValues.row.id}`
                );
              }}
            >
              {editIcon}
            </span>
            <span
              className={styles.delete_icon_btn}
              onClick={() => {
                handleShowDeleteModal(cellValues.row.id);
              }}
            >
              {deleteIcon}
            </span>
          </>
        );
      },
    },
  ];

  // let rows = [
  //   { id: 1, location: "malaysia", description: "dsffsdfsfsf", title: "check" },
  //   {
  //     id: 2,
  //     location: "singapore",
  //     description: "dsffsdfsfsf",
  //     title: "check",
  //   },
  // ];

  
  const handleDelete = async (id) => {
    const response = await deleteCelebrationlist(id);

    if (response.remote === "success") {
      hideDeleteModal();
      swal("Deleted Successfully!");
      handleCelebrationData()
    } else {
    }
  };
  const handleCelebrationData = async () => {
    
    
    const response = await showCelebrationsList();

    if (response.remote === "success") {
      setCelebrationList(response.data.data)
    } else {
    }
  };
  useEffect(() => {
    handleCelebrationData();
  }, []);

  let rows = [];

  celebrationList?.map((item, index) => {
    rows.push({
      id: item.id,
      location: item.location === '1' ? "Malasiya" : "Singapore",
      description: item.description,
      title: item.title,
    });
  });
  return (
    <>
      <div className={styles.job_list_page}>
        <div className="">
          <div className={styles.card_body}>
            <div className="d-flex align-items-center justify-content-between mt-2 mb-3">
              <div className={styles.page_title}>
                <h3>Manage Banner & Content</h3>
              </div>
              <Button
                className={styles.main_button}
                onClick={() =>
                  navigate("/add-celebration-banner-content")
                }
              >
                Add Banner & Content
              </Button>
            </div>
            {/* <div className="table-search d-flex justify-content-between">
          <div className="show_entries d-flex align-items-center">
            Show
            <select className="form-control ms-1 me-1">
              <option value="10"> 10</option>
              <option value="25"> 25</option>

              <option value="50"> 50</option>

              <option value="100"> 100</option>
            </select>
            Entries
          </div>
          <input
            type="search"
            placeholder="Search.."
            className="form-control mb-3 mt-1"
            style={{ width: "250px" }}
          />
        </div> */}
            <Table rows={rows} columns={columns} />
          </div>
        </div>
      </div>
      <DeleteModal
        showDeleteModal={showDeleteModal}
        handleDelete={handleDelete}
        hideDeleteModal={hideDeleteModal}
        handleShowDeleteModal={handleShowDeleteModal}
        deleteId={deleteId}
      />
    </>
  );
}
